/// <reference path="../../../trackingAndMonitoring/datamodels/tracking.data-models.ts" />
import { Injectable, EventEmitter, Injector } from '@angular/core'
import { Configuration } from '../../configurations/shared.config';
import { Http } from '@angular/http';
//import { Transporter } from '../../dataModels/transporter';
import { AuthenticationService } from '../authentication.service';
import { CounterService } from '../counter.service';
import { TrackedObjectView, TransporterViewIcon } from '../../../trackingAndMonitoring/dataModels/tracking.data-models';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';
@Injectable()
export class TransporterService extends DiagnosedItem {

    public transporterList: TrackedObjectView[] = [];
    private TrackedObjectList: any;

    public filteredList: TrackedObjectView[] = [];

    public transporterUpdated: EventEmitter<TrackedObjectView> = new EventEmitter<TrackedObjectView>();

    public transporterSelected: EventEmitter<TrackedObjectView> = new EventEmitter<TrackedObjectView>();

    public hidenTransporterIds: any = [];

    constructor(private _http: Http, private auth: AuthenticationService, private counterService: CounterService, protected injector: Injector) {
        super(injector);
    }

    public updateTransporter(transporter: TrackedObjectView): void {

        if (transporter && transporter.TrackedObjectId) {

            var index: number;

            //Find transporter Index at transporters array
            index = this.transporterList.findIndex((trans) => trans.TrackedObjectId == transporter.TrackedObjectId);

            var invalidStatus: boolean = false;

            //if is not logged-in
            if (!this.auth.isLogged && transporter.View) {

                //if (transporter.State.State.Movement.Name == "Parking" || transporter.State.State.Movement.Name == "Towing") {
                //    invalidStatus = true;
                //}
            }
           
            if (!transporter.Icon) { transporter.Icon = new TransporterViewIcon() }
            if (transporter.View && transporter.View.SymbolProperties) {
                for (let Symbol of transporter.View.SymbolProperties) {
                    if (Symbol.LayerName == "Disconnected") {
                        transporter.Icon.disconnected = "disconnected-red";
                    }
                    else if (Symbol.LayerName == "SpeedViolation") {
                        transporter.Icon.speed = "speed-red";
                    }
                    else if (Symbol.LayerName == "GeoInViolation") {
                        transporter.Icon.geofence = "geofence-red";
                    }
                    else if (Symbol.LayerName == "GeoOutViolation") {
                        transporter.Icon.geofence = "geofence-red";
                    }
                    else if (Symbol.LayerName == "TempViolation") {
                        transporter.Icon.temprature = "tempratur-red";
                    }
                    else if (Symbol.LayerName == "Panic" || transporter.View.Symbol.LayerName == "Panic") {
                        transporter.Icon.panic = "panic-red";
                    }
                    else if (Symbol.LayerName == "NoSignal") {
                        transporter.Icon.signal = "signal-red";
                    }
                    else if (Symbol.LayerName == "Unplugged") {
                        transporter.Icon.unplugged = "unplugged-red";
                    }

                }
            }
            transporter.IsHiden = this.isVehicleVisible(transporter.TrackedObjectId);
            //if not exist
            if (index < 0 && !invalidStatus) {

                //Add to transporters

                this.transporterList.push(transporter);
            }
            else {
                if (!invalidStatus) {

                    //update existing transporter
                    transporter.LastLocation = this.transporterList[index].Location;
                    this.transporterList[index] = transporter;


                }
                else if (invalidStatus && index >= 0) {

                    //if invalid remove it from list
                    this.transporterList.splice(index, 1);
                }
            }

            //Update Filtered
            index = this.filteredList.findIndex((trans) => trans.TrackedObjectId == transporter.TrackedObjectId);

            //if not exist
            if (index >= 0) {
                //update existing transporter
                this.filteredList[index] = transporter;
            }

            this.transporterUpdated.emit(transporter);
        }
    }
    private isVehicleVisible(Id) {

        var index = this.hidenTransporterIds.findIndex(x => x == Id);
        if (index > -1)
            return true;
        else
            return false;
    }
    public onTransporterSelected(transporter: TrackedObjectView): void {

        if (transporter) {
            this.transporterSelected.emit(transporter);
        }
    }

    private updateTransporterFromAnother(origTransporter: TrackedObjectView, newTransporter: TrackedObjectView) {
        if (origTransporter && newTransporter) {

            for (var x in newTransporter) {
                origTransporter[x] = newTransporter[x];
            }
        }
    }

    public clear() {
        this.transporterList = [];
        this.filteredList = [];
    }

    async loadTrackedObjectList(): Promise<any> {

        var response = await this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.TrackedObjectIconURl).toPromise()
            .then(response => {

                this.TrackedObjectList = response ? JSON.parse(response.text()) : null
                return this.TrackedObjectList;
            })
            .catch(error => {

            });
        return response;
    }
    async loadTransporterDetails(DisplayName): Promise<any> {
        var response = await this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.TransporterDetailsInfFromDisplayNameUrl + DisplayName).toPromise()
            .then(response => response ? JSON.parse(response.text()) : null)
            

        return response;
    }

    public getStaffAllocatedVehicle(vehicleId) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.GetStaffAllocatedVehicle, vehicleId).map(res => res.json());
    }

    public getStaffInf(obj) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.getStaffInf, obj).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/transporters/transporter.service.ts